import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconNotification = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3150_3056)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M15 9.66671V13.8334L16.6667 15.5V16.3334H3.33337V15.5L5.00004 13.8334V9.66671C5.00004 7.10004 6.35837 4.96671 8.75004 4.40004V3.83337C8.75004 3.14171 9.30837 2.58337 10 2.58337C10.6917 2.58337 11.25 3.14171 11.25 3.83337V4.40004C13.6334 4.96671 15 7.10837 15 9.66671Z",
			fill: "#707070"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M11.6667 17.1667C11.6667 18.0834 10.9167 18.8334 10 18.8334C9.07504 18.8334 8.33337 18.0834 8.33337 17.1667H11.6667Z",
			fill: "#707070"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3150_3056",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white",
			transform: "translate(0 0.5)"
		})
	}) })]
});
export default SvgIconNotification;
